var a = {};
export {
  a as __exports
};
//# sourceMappingURL=index.es492.js.map
